import { render, staticRenderFns } from "./fireFox.vue?vue&type=template&id=050cfda0&scoped=true"
import script from "./fireFox.vue?vue&type=script&lang=js"
export * from "./fireFox.vue?vue&type=script&lang=js"
import style0 from "./fireFox.vue?vue&type=style&index=0&id=050cfda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050cfda0",
  null
  
)

export default component.exports